import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'bt-slider-image',
  templateUrl: './slider-image.component.html',
  styleUrls: ['./slider-image.component.scss']
})
export class SliderImageComponent implements OnInit, OnChanges {
  @ViewChild('fileMulti') fileMulti: ElementRef<any>;
  config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 1,
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: false,
    allowTouchMove: true,
    centeredSlides: false,
    spaceBetween: 0,
  };

  @Input() sliderPicture = [];
  @Input() count = 4;
  @Input() disabeled = false;
  @Input() sliderThumbPicture = [];
  @Output() sliderPicSelected = new EventEmitter();
  sliderPictureBase64 = [];
  imageFile = [];
  index = 0;


  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.sliderPicSelected.emit(
      {
        sliderPicture: this.sliderPicture,
        sliderThumbPicture: this.sliderThumbPicture,
        imageFiles: this.imageFile
      }
    );
  }
  pictureSliderClick() {
    if (this.sliderPicture.length < this.count) {
      this.fileMulti.nativeElement.click();
    } else {
      this.commonService.showErrorSnackBar(`حداکثر ${this.count} اسلایدر می توان انتخاب کرد`);
    }
  }
  removePicture(index) {
    this.sliderPicture.splice(index, 1);
    this.sliderThumbPicture.splice(index, 1);
    this.sliderPicSelected.emit(
      {
        sliderPicture: this.sliderPicture,
        sliderThumbPicture: this.sliderThumbPicture,
        imageFile: this.imageFile
      }
    );
    this.sliderPictureBase64.splice(index, 1);
    index--;
  }
  removeBase64Picture(index) {
    this.imageFile.splice(index, 1);
    this.sliderPictureBase64.splice(index, 1);
    this.sliderPicSelected.emit(
      {
        sliderPicture: this.sliderPicture,
        sliderThumbPicture: this.sliderThumbPicture,
        imageFiles: this.imageFile
      }
    );
    index--;
  }
  async onPictureSliderAdded(event) {
    if (event) {
      for (const item of event.srcElement.files) {
        this.imageFile.push(item);
        this.sliderPictureBase64.push(await toBase64(item) as string);
      }
      this.sliderPicSelected.emit(
        {
          sliderPicture: this.sliderPicture,
          sliderThumbPicture: this.sliderThumbPicture,
          imageFiles: this.imageFile
        }
      );
    }
  }
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
